var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _FilteredRemoteSelection_remote, _FilteredRemoteSelection_filter, _FilteredRemoteSelection_mapping, _FilteredRemoteSelection_listeners, _FilteredRemoteSelection_values, _FilteredRemoteSelection_subscription;
import { isDefined, Listeners } from "@opendaw/lib-std";
import { Address } from "@opendaw/lib-box";
/**
 * Scoped, read only view over {@link RemoteSelections}, reusing the *same* predicate + mapping as the
 * matching local {@link FilteredSelection}. Scope is preserved: a remote note selection only ever
 * reaches the note scoped view, never the region renderer.
 *
 * The mapped value is resolved once on selection (while the box is attached) and cached, so a
 * deselection that arrives after the selectable box was deleted never re-resolves an adapter for an
 * already detached box. This mirrors {@link FilteredSelection}, which returns the stored value on
 * deselect rather than mapping again.
 */
export class FilteredRemoteSelection {
    constructor(remote, filter, mapping) {
        _FilteredRemoteSelection_remote.set(this, void 0);
        _FilteredRemoteSelection_filter.set(this, void 0);
        _FilteredRemoteSelection_mapping.set(this, void 0);
        _FilteredRemoteSelection_listeners.set(this, void 0);
        _FilteredRemoteSelection_values.set(this, void 0); // cache keyed by selectable address
        _FilteredRemoteSelection_subscription.set(this, void 0);
        __classPrivateFieldSet(this, _FilteredRemoteSelection_remote, remote, "f");
        __classPrivateFieldSet(this, _FilteredRemoteSelection_filter, filter, "f");
        __classPrivateFieldSet(this, _FilteredRemoteSelection_mapping, mapping, "f");
        __classPrivateFieldSet(this, _FilteredRemoteSelection_listeners, new Listeners(), "f");
        __classPrivateFieldSet(this, _FilteredRemoteSelection_values, Address.newSet(entry => entry.selectable), "f");
        __classPrivateFieldSet(this, _FilteredRemoteSelection_subscription, __classPrivateFieldGet(this, _FilteredRemoteSelection_remote, "f").catchupAndSubscribe({
            onSelected: (selectable, user) => {
                if (!__classPrivateFieldGet(this, _FilteredRemoteSelection_filter, "f").call(this, selectable)) {
                    return;
                }
                const existing = __classPrivateFieldGet(this, _FilteredRemoteSelection_values, "f").getOrNull(selectable.address);
                if (isDefined(existing)) {
                    existing.owners++;
                    __classPrivateFieldGet(this, _FilteredRemoteSelection_listeners, "f").proxy.onSelected(existing.value, user);
                }
                else {
                    const value = __classPrivateFieldGet(this, _FilteredRemoteSelection_mapping, "f").fy(selectable);
                    __classPrivateFieldGet(this, _FilteredRemoteSelection_values, "f").add({ selectable: selectable.address, value, owners: 1 });
                    __classPrivateFieldGet(this, _FilteredRemoteSelection_listeners, "f").proxy.onSelected(value, user);
                }
            },
            onDeselected: (selectable, user) => {
                const existing = __classPrivateFieldGet(this, _FilteredRemoteSelection_values, "f").getOrNull(selectable.address);
                if (!isDefined(existing)) {
                    return;
                }
                if (--existing.owners === 0) {
                    __classPrivateFieldGet(this, _FilteredRemoteSelection_values, "f").removeByKey(selectable.address);
                }
                __classPrivateFieldGet(this, _FilteredRemoteSelection_listeners, "f").proxy.onDeselected(existing.value, user);
            }
        }), "f");
    }
    ownersOf(selectable) {
        return __classPrivateFieldGet(this, _FilteredRemoteSelection_remote, "f").ownersOf(__classPrivateFieldGet(this, _FilteredRemoteSelection_mapping, "f").fx(selectable));
    }
    subscribe(listener) { return __classPrivateFieldGet(this, _FilteredRemoteSelection_listeners, "f").subscribe(listener); }
    catchupAndSubscribe(listener) {
        __classPrivateFieldGet(this, _FilteredRemoteSelection_remote, "f").forEach(({ selectable, user }) => {
            const existing = __classPrivateFieldGet(this, _FilteredRemoteSelection_values, "f").getOrNull(selectable.address);
            if (isDefined(existing)) {
                listener.onSelected(existing.value, user);
            }
        });
        return this.subscribe(listener);
    }
    terminate() { __classPrivateFieldGet(this, _FilteredRemoteSelection_subscription, "f").terminate(); }
}
_FilteredRemoteSelection_remote = new WeakMap(), _FilteredRemoteSelection_filter = new WeakMap(), _FilteredRemoteSelection_mapping = new WeakMap(), _FilteredRemoteSelection_listeners = new WeakMap(), _FilteredRemoteSelection_values = new WeakMap(), _FilteredRemoteSelection_subscription = new WeakMap();
